<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-10 offset-lg-1 col-12 mb-3">
                <div class="card">
                    <div class="card-header blue-gradient">Menú app</div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="table-responsive">
                                    <table class="table table-bordered table-sm" style="width: 100%" id="menu-table">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Valor</th>
                                                <th scope="col">Estado</th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="menu in menus" :key="menu.id">
                                                <td>{{ menu.id }}</td>
                                                <td>
                                                    <input type="text" placeholder="Valor" style="border-radius: 0px; border: none; border-bottom: 1px solid gray" v-model="menu.value">
                                                </td>
                                                <td class="text-center">
                                                    <p>{{ (menu.status) ? 'Activo' : 'Inactivo' }}</p>
                                                </td>
                                                <td width="50px">
                                                    <a href="#" class="btn btn-danger btn-sm" @click="changeStatusMenu(menu)"><i class="fa fa-ban"></i></a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-12">
                                <button @click="updateMenu()" class="btn btn-warning mt-3">Actualizar valores</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'cities',
    mounted: function(){
        this.fetchMenu();
    },
    data(){
        return {
            baseUrl: process.env.VUE_APP_API,
            currentCity: null,
            menus: {}
        }
    },
    methods: {
        fetchMenu: function(){
            let loader = this.$loading.show();
            
            let _this = this;
            this.$http
            .get(`${this.baseUrl}/public/menu`)
            .then(data => {
                const allMenus = data.body.data;
                const menus = [];

                allMenus.forEach((menu) => {
                    if (menu.id !== 10) {
                        menus.push(menu);
                    }
                });
                _this.menus = menus;
                loader.hide();

                console.log(_this.menus);
            })
            .catch(error => {
                console.log(error.error);
                loader.hide();
            });
        },
        updateMenu: function() {
            let loader = this.$loading.show();
            this.$http.put(`${this.baseUrl}/admin/menu`, {menu: this.menus})
            .then(() => {
                this.$dialogs.alert("Menú actualizado con exito", {title: "Éxito", size: "sm"});
                this.fetchMenu();
                loader.hide();
                // window.location.reload();
            })
            .catch(error => {
                console.log(error.error);
                loader.hide();
            });
        },
        changeStatusMenu: function(menu) {
            let loader = this.$loading.show();
            this.$http.put(`${this.baseUrl}/admin/menu/${menu.id}`, {status: !menu.status})
            .then(() => {
                this.fetchMenu();
                this.$dialogs.alert("Estado del menú actualizado con exito", {title: "Éxito", size: "sm"});
                loader.hide();
                window.location.reload();
            })
            .catch(error => {
                console.log(error.error);
                loader.hide();
            });
        }
    }

}
</script>
<style lang="sass" scoped>
    @import '../../assets/scss/colors';
</style>


